import React, {useEffect, useState} from "react"
import {useForm} from "react-hook-form";
import "./goals.scss"
import {GetGoals} from "../../../services/goals";
import GoalsSkeleton from "../../skeletons/goals/GoalSkeleton";
import {DropDownCheck, SFilterIcon} from "../../../../assets/icons/defaultIcons";
import {Dropdown} from "antd";
import {useUser} from "../../../providers/UserContext";

export default function Goals() {
    const [showOtherGoals, setShowOtherGoals] = useState(false)
    const [monthOptions, setMonthOptions] = useState([])
    const [addGoal, setAddGoal] = useState(false);
    const [goalSelectedCategroy, setGoalSelectedCategory] = useState('');
    const [updateGoals, setUpdateGoals] = useState(false);
    const [goalData, setGoalData] = useState();
    const [goalLoader, setGoalsLoader] = useState(true);
    const [selectedItem, setSelectedItem] = useState("All");
    const { selectedYear, setSelectedYear } = useUser();
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch
    } = useForm({
        mode: "onChange",
        defaultValues: {
            quarter: "1",  // Default Quarter 1
            month: "1"    // Default January
        }
    });


    async function GetAllGoals() {
        setGoalsLoader(true); // ✅ Start Loader Before API Call
        try {
            const response = await GetGoals({ year: selectedYear });
            console.log(response?.data?.data, 'response');
            setGoalData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching goals:", error);
        } finally {
            setGoalsLoader(false); // ✅ Stop Loader After API Call Completes
        }
    }


    useEffect(()=>{
        GetAllGoals()
    },[updateGoals, selectedYear])

    function handleAddAnnualGoal() {
        setAddGoal(true)
        setGoalSelectedCategory(1)
    }

    const items = [
        {
            key: "1",
            label: (
                <a onClick={() => setSelectedYear(2026)} className="d-flex justify-content-between w-100">
                    2026 {selectedYear === 2026 && <DropDownCheck />}
                </a>
            )
        },
        {
            key: "2",
            label: (
                <a onClick={() => setSelectedYear(2025)} className="d-flex justify-content-between w-100">
                    2025 {selectedYear === 2025 && <DropDownCheck />}
                </a>
            )
        },
        {
            key: "3",
            label: (
                <a onClick={() => setSelectedYear(2024)} className="d-flex justify-content-between w-100">
                    2024 {selectedYear === 2024 && <DropDownCheck />}
                </a>
            )
        },
    ];

    if (goalLoader){
        return <GoalsSkeleton/>
    }

    return(
        <div className={'goals'}>
            <div className={'goals-heading'}>
                <h2></h2>
                <div className={'btns-wrapper'}>
                    <span>
                     <Dropdown menu={{ items }} placement="bottomLeft" trigger={["click"]}>
                        <span className="goal-dropdown">
                            <SFilterIcon /> {selectedYear}
                        </span>
                    </Dropdown>
                    </span>
                </div>
            </div>
            {/*<div className="goals-section">*/}
            {/*    <Row>*/}
            {/*        <Col md={6}>*/}
            {/*            <GoalsBox*/}
            {/*                GoalHeading="Faith Goals"*/}
            {/*                GoalEmptyHeading="Add Faith Goals"*/}
            {/*                GoalIcon="https://s3.amazonaws.com/riseup-backend/VrX2HhpHowzA"*/}
            {/*                boxColor="#00E6A9"*/}
            {/*                iconColor="#40C9A2"*/}
            {/*                Color="#E5FFF9"*/}
            {/*                backgroundColor="#40C9A205"*/}
            {/*                onClick={handleAddAnnualGoal}*/}
            {/*                data={goalData?.data?.Faith}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col md={6}>*/}
            {/*            <GoalsBox*/}
            {/*                GoalHeading="Family Goals"*/}
            {/*                GoalEmptyHeading="Add Family Goals"*/}
            {/*                GoalIcon="https://s3.amazonaws.com/riseup-backend/2E0z0JloaIKP"*/}
            {/*                boxColor="#FF5C5C"*/}
            {/*                iconColor="#F95C59"*/}
            {/*                Color="#FFE5E5"*/}
            {/*                backgroundColor="#F95C5905"*/}
            {/*                onClick={handleAddAnnualGoal}*/}
            {/*                data={goalData?.data?.Family}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col md={6}>*/}
            {/*            <GoalsBox*/}
            {/*                GoalHeading="Fitness Goals"*/}
            {/*                GoalEmptyHeading="Add Fitness Goals"*/}
            {/*                GoalIcon="https://s3.amazonaws.com/riseup-backend/KXGBI4jGBJcH"*/}
            {/*                boxColor="#00B2FF"*/}
            {/*                iconColor="#24B9C2"*/}
            {/*                Color="#E5F7FF"*/}
            {/*                backgroundColor="#24B9C205"*/}
            {/*                onClick={handleAddAnnualGoal}*/}
            {/*                data={goalData?.data?.Fitness}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col md={6}>*/}
            {/*            <GoalsBox*/}
            {/*                GoalHeading="Finance Goals"*/}
            {/*                GoalEmptyHeading="Add Finance Goals"*/}
            {/*                GoalIcon="https://s3.amazonaws.com/riseup-backend/ZmxcOFkt6NVx"*/}
            {/*                boxColor="#FFB800"*/}
            {/*                iconColor="#DCAB43"*/}
            {/*                Color="#FFF8E5"*/}
            {/*                backgroundColor="#DCAB4305"*/}
            {/*                onClick={handleAddAnnualGoal}*/}
            {/*                data={goalData?.data?.Finance}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col md={6}>*/}
            {/*            <GoalsBox*/}
            {/*                GoalHeading="Other Goals"*/}
            {/*                GoalEmptyHeading="Add Others Goals"*/}
            {/*                boxColor="white"*/}
            {/*                iconColor="white"*/}
            {/*                Color="#F7E5FF"*/}
            {/*                backgroundColor="#BBBBBB05"*/}
            {/*                hasSwitch={true}*/}
            {/*                onClick={handleAddAnnualGoal}*/}
            {/*                data={goalData?.data?.Others}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*    </Row>*/}


            {/*</div>*/}
            {/*<ThemeModals*/}
            {/*    open={addGoal}*/}
            {/*    close={setAddGoal}*/}
            {/*    title={"Add Annual Goals"} // Each item in its own div*/}
            {/*    content={*/}
            {/*        <AddAnnualGoals*/}
            {/*            close={setAddGoal}*/}
            {/*            goalSelectedCategroy={goalSelectedCategroy}*/}
            {/*            setGoalSelectedCategory={setGoalSelectedCategory}*/}
            {/*            updateGoals={updateGoals}*/}
            {/*            setUpdateGoals={setUpdateGoals}*/}

            {/*        />*/}
            {/*    }*/}
            {/*/>*/}
        </div>
    )
}